import { useState } from "react";
import { Bell } from "lucide-react";

const NotificationBell = ({ notifications, onRead, onReadAll, copy }) => {
  const [open, setOpen] = useState(false);
  const unread = notifications.filter((item) => !item.read).length;

  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen(!open)} className="relative inline-flex items-center justify-center rounded-xl border border-white/10 bg-[#18181B] p-3 text-white hover:border-[#CCFF00]/40">
        <Bell className="h-5 w-5" />
        {unread > 0 && <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#CCFF00] px-1 text-xs font-black text-black">{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-3 w-[min(92vw,400px)] overflow-hidden rounded-2xl border border-white/10 bg-[#111111] shadow-2xl">
          <div className="flex items-center justify-between border-b border-white/10 p-4">
            <div>
              <p className="text-xs uppercase text-zinc-500">{copy.title}</p>
              <h3 className="text-lg font-black text-white">{copy.history}</h3>
            </div>
            {notifications.length > 0 && <button onClick={onReadAll} className="text-xs font-bold uppercase text-[#CCFF00]">{copy.readAll}</button>}
          </div>
          <div className="max-h-96 overflow-y-auto p-2">
            {notifications.length === 0 ? (
              <p className="p-4 text-sm text-zinc-500">{copy.empty}</p>
            ) : notifications.map((item) => (
              <button key={item.notification_id} type="button" onClick={() => onRead(item.notification_id)} className={`w-full rounded-xl p-3 text-left hover:bg-white/5 ${item.read ? "opacity-60" : ""}`}>
                <p className="text-sm font-bold text-white">{item.title}</p>
                <p className="text-xs text-zinc-500">{item.message}</p>
                {!item.read && <p className="mt-1 text-xs text-[#CCFF00]">{copy.new}</p>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
